import { getLastArticleContainer } from '../article-page/helper'

export default function (tns) {
  const lastArticleContainer = getLastArticleContainer()

  if (!lastArticleContainer) {
    return
  }

  const blocks = Array.from(
    lastArticleContainer.querySelectorAll(
      '.ArticleContent__entry .wp-block-product-infusion-block-product-infusion-multiple .ProductInfusionMultiple'
    )
  )

  blocks.forEach((block) =>
    applyTinySlideConfigs(
      block,
      {
        0: {
          gutter: 0,
          items: 1,
        },
        500: {
          items: 2,
        },
        768: {
          items: 3,
        },
      },
      tns
    )
  )
}

function applyTinySlideConfigs(slider, responsive, tns) {
  return tns({
    container: slider,
    gutter: 0,
    nav: true,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    loop: false,
    preventScrollOnTouch: 'force',
    responsive: responsive,
  })
}
